import { FullRoute } from '../../models/full-route.model';

export class SetLiquidity {
  static readonly type = '[LIQUIDITY ] Set user liquidity';

  constructor(public payload: FullRoute) {
  }
}

